import apiErrorModel from '../models/apiErrorModel';

export function handleEventListResponse(response, onSuccess, onError) {
  if (apiErrorModel.hasError(response)) {
    onError(response.error);
    return;
  }

  if (!Array.isArray(response)) {
    onError(apiErrorModel.normalizeUnexpectedResponse(apiErrorModel.createRequestId()));
    return;
  }

  const attendees = [];
  response.forEach((event) => {
    const tickets = event.tickets || [];
    tickets.forEach((ticket) => {
      ticket.eventName = event.name;
      attendees.push(ticket);
    });
  });

  onSuccess(response, attendees);
}

export default handleEventListResponse;
